import { LOCALES, messagesFor, useI18n } from '@/locales';
import { cn } from '@/lib/cn';

export function LanguageSwitch({ className }: { className?: string }) {
  const { locale, setLocale } = useI18n();
  return (
    <div className={cn('flex rounded-full bg-ink-850 p-0.5 ring-1 ring-line', className)}>
      {LOCALES.map((code) => {
        const meta = messagesFor(code).meta;
        return (
          <button
            key={code}
            type="button"
            lang={code}
            aria-label={meta.langName}
            aria-pressed={code === locale}
            onClick={() => setLocale(code)}
            className={cn(
              'h-7 rounded-full px-2.5 text-xs font-bold tracking-wide transition-colors',
              code === locale ? 'bg-ink-600 text-fg' : 'text-fg-subtle hover:text-fg',
            )}
          >
            {meta.short}
          </button>
        );
      })}
    </div>
  );
}
